import { Theme } from "../enums/theme";

export const ThemeReverseMap = {
  [Theme.Dark]: Theme.Light,
  [Theme.Light]: Theme.Dark,
};
